// extracted by mini-css-extract-plugin
export var closeButton = "_jc-1";
export var closeX = "_jc-3";
export var container = "_jc-0";
export var image = "_jc-2";